









































import 'reflect-metadata'
import { Component, Vue, Prop, Watch,  } from 'vue-property-decorator'

@Component
export default class DatePicker extends Vue { 
	@Prop(Function) public updateState: any
	@Prop() public value: any
	@Prop() public disabled: any
	@Prop() public error: any
	@Prop() public errorMessages: any
	
	menu = false
	date = ""
	monthText = ['มกราคม','กุมภาพันธ์', 'มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']

	@Watch('value', { immediate: true, deep: true })
  	onDateChanged(val: string, oldVal: string) {
		this.date = val
	}


	get dateText() {
      	if (this.date) {
			const [year, month, day] = this.date.split("-")
			return `${day}/${month}/${year}`
		}
    }

	set dateText (newValue: any) {
		this.date = newValue === null ? "" : newValue
		this.updateState(this.date)
	}

	setYear (date: string){
		return date.substring(0, 4)
	}

	setHeaderDate (date: string) {
		const splitDate: any[] = date.split("-")
		const myText = `${this.monthText[splitDate[1]-1] === undefined ? '' : this.monthText[splitDate[1]-1]} ${date.substring(0, 4)}`
		return myText
	}

	changeDate() {
		this.updateState(this.date)
		this.menu = false
	}
}
